var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row no-gutters align-items-center" }, [
    _c("i", {
      staticClass: "tiny-font mb-2 position-absolute",
      class: _vm.typeDefinition.icon,
      staticStyle: { "font-size": "0.9rem" },
      attrs: {
        "aria-hidden": "true",
        "data-toggle": "tooltip",
        "data-original-title": _vm.typeDefinition.text,
      },
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c("material-input", {
          attrs: {
            value: _vm.name,
            label: _vm.$t("account.name"),
            disabled: !_vm.editable,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }